module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1160.00f29028.png";